import React from 'react';
import './DualRangeSlider.css';

type DualRangeSliderProps = {
  label: string;
  min: number;
  max: number;
  value: [number, number];
  onChange: (next: [number, number]) => void;
  formatValue?: (value: number) => string;
};

const defaultFormatValue = (value: number) => new Intl.NumberFormat('ru-RU').format(Math.round(value));

function toPercent(value: number, min: number, max: number): number {
  if (max <= min) return 0;
  return ((value - min) / (max - min)) * 100;
}

const DualRangeSlider: React.FC<DualRangeSliderProps> = ({
  label,
  min,
  max,
  value,
  onChange,
  formatValue = defaultFormatValue,
}) => {
  // При min === max (одно значение в выборке) слайдер всё ещё валиден; отключаем только при некорректном диапазоне.
  const disabled = max < min;
  const leftValue = Math.max(min, Math.min(value[0], value[1]));
  const rightValue = Math.min(max, Math.max(value[1], value[0]));

  const leftPct = toPercent(leftValue, min, max);
  const rightPct = toPercent(rightValue, min, max);

  return (
    <div className="dc-dual-range">
      <div className="dc-dual-range__label">{label}</div>
      <div className="dc-dual-range__row">
        <div className="dc-dual-range__value">{formatValue(leftValue)}</div>
        <div className="dc-dual-range__slider-wrap">
          <div className="dc-dual-range__track" />
          <div
            className="dc-dual-range__track-active"
            style={{ left: `${leftPct}%`, width: `${Math.max(0, rightPct - leftPct)}%` }}
          />
          <input
            type="range"
            min={min}
            max={max}
            step={1}
            value={leftValue}
            disabled={disabled}
            className="dc-dual-range__input dc-dual-range__input--left"
            onChange={(e) => {
              const nextMin = Number(e.target.value);
              onChange([Math.min(nextMin, rightValue), rightValue]);
            }}
          />
          <input
            type="range"
            min={min}
            max={max}
            step={1}
            value={rightValue}
            disabled={disabled}
            className="dc-dual-range__input dc-dual-range__input--right"
            onChange={(e) => {
              const nextMax = Number(e.target.value);
              onChange([leftValue, Math.max(nextMax, leftValue)]);
            }}
          />
        </div>
        <div className="dc-dual-range__value">{formatValue(rightValue)}</div>
      </div>
    </div>
  );
};

export default DualRangeSlider;
